import { useEffect, useState } from "react";
import { api, formatEUR } from "../lib/apiClient";

const fmtWhen = (iso) => new Intl.DateTimeFormat("es-ES", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
const fmtVal = (v) => (v === null || v === undefined || v === "" ? "—" : String(v));

const ItemRow = ({ kind, item }) => {
  const d = item.after - item.before;
  return (
    <div className="flex justify-between gap-3 text-xs py-1" data-testid={`adj-item-${kind}-${item.slot}`}>
      <span className={kind === "extra" ? "text-rose-700" : "text-emerald-700"}>
        {kind === "extra" ? item.label : `Descuento · ${item.label}`}
      </span>
      <span className="font-mono whitespace-nowrap">
        {formatEUR(item.before)} → {formatEUR(item.after)} <span className="text-zinc-500">({d > 0 ? "+" : ""}{formatEUR(d)})</span>
      </span>
    </div>
  );
};

const Entry = ({ e }) => (
  <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-zinc-100 text-sm" data-testid={`adj-entry-${e.id}`}>
    <div className="col-span-3">
      <p className="font-mono text-xs">{fmtWhen(e.at)}</p>
      <p className="text-xs text-zinc-500 mt-0.5" data-testid={`adj-user-${e.id}`}>{e.user_name || e.user_email}</p>
    </div>
    <div className="col-span-3">
      <p className="font-medium">{e.restaurant_name}</p>
      {(e.data_changes || []).map((c) => (
        <p key={c.field} className="text-xs text-zinc-500 font-mono">{c.field}: {fmtVal(c.before)} → {fmtVal(c.after)}</p>
      ))}
    </div>
    <div className="col-span-6">
      {(e.extras || []).map((x) => <ItemRow key={`x-${x.slot}`} kind="extra" item={x} />)}
      {(e.discounts || []).map((x) => <ItemRow key={`d-${x.slot}`} kind="discount" item={x} />)}
    </div>
  </div>
);

export const AdjustmentsHistory = ({ waveId }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/invoice-adjustments").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [waveId]);

  return (
    <section data-testid="adjustments-history">
      <p className="text-sm text-zinc-600 mb-4 max-w-3xl">
        Extras y descuentos generados al cambiar los datos de un restaurante con facturas ya emitidas o pagadas.
      </p>
      <div className="bg-white border border-zinc-200">
        <div className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-zinc-200 text-xs uppercase tracking-wider text-zinc-500 font-semibold">
          <div className="col-span-3">Fecha · quién</div>
          <div className="col-span-3">Restaurante · cambio de datos</div>
          <div className="col-span-6">Extras y descuentos</div>
        </div>
        {items === null && <div className="p-6 text-sm text-zinc-500 font-mono">Cargando…</div>}
        {items?.length === 0 && <div className="p-6 text-sm text-zinc-500" data-testid="adjustments-empty">Todavía no hay ajustes por cambios de datos.</div>}
        {items?.map((e) => <Entry key={e.id} e={e} />)}
      </div>
    </section>
  );
};
